"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderArticle = void 0;
var Article_1 = require("../Article");
var types_1 = require("../types");
var OrderArticle = /** @class */ (function (_super) {
    __extends(OrderArticle, _super);
    function OrderArticle(params) {
        var _this = _super.call(this, params) || this;
        _this.articleState = params.articleState;
        _this.issues = params.issues;
        _this.ptOrderId = params.ptOrderId;
        _this.state = params.state;
        _this.pos = params.pos;
        _this.currencyCode = params.currencyCode;
        _this.pickingId = params.pickingId;
        _this.pickedQuantity = params.pickedQuantity;
        _this.ptOrderArticleId = params.ptOrderArticleId;
        _this.source = params.source;
        _this.sourceArticleId = params.sourceArticleId;
        _this.sourceOrderId = params.sourceOrderId;
        _this.updatedAt = params.updatedAt;
        _this.locationInfo = params.locationInfo;
        _this.locations = params.locations;
        _this.buyer = params.buyer;
        _this.sortIndex = params.sortIndex;
        return _this;
    }
    OrderArticle.prototype.copy = function () {
        var _a, _b;
        return new OrderArticle(__assign(__assign({}, this.toPlainObject()), { articleState: this.articleState, issues: (_a = this.issues.map(function (issue) { return (__assign({}, issue)); })) !== null && _a !== void 0 ? _a : [], ptOrderId: this.ptOrderId, state: this.state ? __assign({}, this.state) : undefined, pos: this.pos, currencyCode: this.currencyCode, pickingId: this.pickingId, pickedQuantity: this.pickedQuantity, ptOrderArticleId: this.ptOrderArticleId, source: this.source, sourceArticleId: this.sourceArticleId, sourceOrderId: this.sourceOrderId, updatedAt: this.updatedAt, locationInfo: this.locationInfo ? __assign({}, this.locationInfo) : null, locations: (_b = this.locations.map(function (loc) { return (__assign({}, loc)); })) !== null && _b !== void 0 ? _b : [], buyer: this.buyer ? __assign({}, this.buyer) : undefined, sortIndex: this.sortIndex }));
    };
    OrderArticle.prototype.toPlainObject = function () {
        var _a;
        return __assign(__assign({}, _super.prototype.toPlainObject.call(this)), { articleState: this.articleState, issues: this.issues, ptOrderId: this.ptOrderId, state: this.state, pos: this.pos, currencyCode: this.currencyCode, pickingId: this.pickingId, pickedQuantity: this.pickedQuantity, ptOrderArticleId: this.ptOrderArticleId, source: this.source, sourceArticleId: this.sourceArticleId, sourceOrderId: this.sourceOrderId, updatedAt: this.updatedAt, locationInfo: this.locationInfo, locations: (_a = this.locations.map(function (loc) { return (__assign({}, loc)); })) !== null && _a !== void 0 ? _a : [], buyer: this.buyer ? __assign({}, this.buyer) : undefined, sortIndex: this.sortIndex });
    };
    OrderArticle.prototype.getLocalizedName = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        var name = (_b = (_a = this.card) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '';
        if (this.idLanguage === types_1.CardLanguage.German) {
            return ((_e = (_d = (_c = this.card) === null || _c === void 0 ? void 0 : _c.locNames) === null || _d === void 0 ? void 0 : _d.DE) === null || _e === void 0 ? void 0 : _e.trim()) || name;
        }
        if (this.idLanguage === types_1.CardLanguage.French) {
            return ((_h = (_g = (_f = this.card) === null || _f === void 0 ? void 0 : _f.locNames) === null || _g === void 0 ? void 0 : _g.FR) === null || _h === void 0 ? void 0 : _h.trim()) || name;
        }
        if (this.idLanguage === types_1.CardLanguage.Spanish) {
            return ((_l = (_k = (_j = this.card) === null || _j === void 0 ? void 0 : _j.locNames) === null || _k === void 0 ? void 0 : _k.ES) === null || _l === void 0 ? void 0 : _l.trim()) || name;
        }
        if (this.idLanguage === types_1.CardLanguage.Italian) {
            return ((_p = (_o = (_m = this.card) === null || _m === void 0 ? void 0 : _m.locNames) === null || _o === void 0 ? void 0 : _o.IT) === null || _p === void 0 ? void 0 : _p.trim()) || name;
        }
        return name;
    };
    return OrderArticle;
}(Article_1.RichArticle));
exports.OrderArticle = OrderArticle;
//# sourceMappingURL=OrderArticle.js.map